import { css } from '@emotion/react';
import { ActionIcon, Box, COLOR_PALETTE, Flex, Icon } from '@inflearn/ds-react';
import { useTranslateComponent } from '@inflearn/i18n-tools';
import { faLinkSimple } from '@inflearn/pro-regular-svg-icons';

import { NEXT_PUBLIC_RALLIT_HOST } from '../../../appConfig';
import { INFLEARN_URL } from '../../constants/urls';
import { useIsWebview } from '../../hooks/useIsWebview';

const Header = () => {
  const isWebview = useIsWebview();
  const RallitIcon = useTranslateComponent({
    ko: (
      <ActionIcon
        component="a"
        target="_blank"
        href={NEXT_PUBLIC_RALLIT_HOST}
        size={56}
        css={styleLogoAnchor}
      >
        <IconRallit />
      </ActionIcon>
    ),
    en: (
      <Box w={56} h={56} css={styleLogoAnchor}>
        <IconRallit />
      </Box>
    ),
  });

  if (isWebview) {
    return null;
  }

  return (
    <Flex align="center" gap={8} mb={32}>
      <ActionIcon
        component="a"
        target="_blank"
        href={INFLEARN_URL.MAIN()}
        size={56}
        css={styleLogoAnchor}
      >
        <IconInflearn />
      </ActionIcon>
      <Icon icon={faLinkSimple} width={24} />
      {RallitIcon}
    </Flex>
  );
};

const IconInflearn = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
    <path
      d="M20.2431 7.12192C19.7223 5.92866 19.0192 4.86511 18.1339 3.9572C17.2225 3.04929 16.1809 2.32296 14.9831 1.80415C13.7853 1.28534 12.4834 1 11.1033 1C9.74922 1 8.44726 1.23346 7.22341 1.75227C5.99956 2.27108 4.93194 2.97147 3.99453 3.85344C3.05711 4.76135 2.32801 5.79896 1.80722 6.99222C1.28643 8.18547 1 9.48249 1 10.8573C1 12.2062 1.23435 13.5032 1.75514 14.7224C2.27593 15.9416 2.97899 17.0052 3.89037 17.939C4.80175 18.8729 5.86936 19.5992 7.06717 20.118C8.29102 20.6368 9.56695 20.9222 10.947 20.9222L20.9201 21L20.9982 11.013C21.0243 9.63813 20.7639 8.34112 20.2431 7.12192ZM7.84835 18.2763C6.88489 17.8612 6.0256 17.2646 5.29649 16.5383C4.56739 15.786 3.99453 14.93 3.5779 13.9702C3.16127 12.9844 2.97899 11.9728 2.97899 10.8833C2.97899 9.76783 3.21335 8.73022 3.62998 7.77043C4.0466 6.81064 4.64551 5.98055 5.37461 5.25422C6.12975 4.52789 6.98905 3.98314 7.95251 3.56809C8.942 3.15305 9.95754 2.97147 11.0512 2.97147C12.1709 2.97147 13.2125 3.20493 14.1759 3.61997C15.1394 4.03502 15.9726 4.60571 16.7017 5.35798C17.4308 6.0843 17.9777 6.94034 18.3943 7.90013C18.8109 8.85992 18.9932 9.89754 18.9932 11.013L18.9411 17.7056L11.8063 10.4682L13.3947 6.11025C13.577 5.64332 13.3166 5.12451 12.8479 4.94293C12.3792 4.76135 11.8584 5.02075 11.6761 5.48768L10.4002 9.01556L8.16082 6.75875C7.79627 6.39559 7.22341 6.39559 6.88489 6.75875C6.52034 7.12192 6.52034 7.69261 6.88489 8.02983L12.3532 13.607H8.39518C7.90043 13.607 7.4838 14.022 7.4838 14.5149C7.4838 15.0078 7.90043 15.4228 8.39518 15.4228H14.0718C14.0978 15.4228 14.1238 15.4228 14.1238 15.4228L17.6652 19.0026L10.947 18.9507C9.82734 18.9248 8.83785 18.7172 7.84835 18.2763Z"
      fill="#00C471"
      stroke="#00C471"
      strokeWidth="0.5"
    />
  </svg>
);

export const IconRallit = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 11.0896C0 6.16825 3.95232 2.17871 8.82775 2.17871H13.9936V5.87508H8.82775C5.97472 5.87508 3.66188 8.2097 3.66188 11.0896C3.66188 13.9695 5.97472 16.3041 8.82775 16.3041C11.6808 16.3041 13.9936 13.9695 13.9936 11.0896V5.87508H17.6555V11.0896C17.6555 16.011 13.7032 20.0005 8.82775 20.0005C3.95232 20.0005 0 16.011 0 11.0896Z"
      fill="#21252A"
    />
    <path
      d="M17.7532 4.15842C18.8908 4.15842 19.813 3.22752 19.813 2.07921C19.813 0.930893 18.8908 0 17.7532 0C16.6156 0 15.6934 0.930893 15.6934 2.07921V4.15842H17.7532Z"
      fill="#00CCAA"
    />
  </svg>
);

const styleLogoAnchor = css({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: 9999,
  border: `1px solid ${COLOR_PALETTE.gray[2]}`,
  background: 'white',
});

export default Header;
